import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import routes from "../pages/configs";
import NotFound from "../pages/NotFound";
import { initGA, logPageView } from "../analytics";

function AnalyticsTracker() {
    const location = useLocation();

    useEffect(() => {
        initGA();
    }, []);

    useEffect(() => {
        logPageView();
    }, [location]);

    return null;
}

function PageRoutes() {
    return (
        <Router>
            <AnalyticsTracker />
            <Routes>
                {routes.map(({ Component, Layout, path, secured, showFooter }, index) => (
                    <Route
                        key={index}
                        path={path}
                        element={
                            <Layout showFooter={showFooter}>
                                <Component />
                            </Layout>
                        }
                    />
                ))}
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Router>
    );
}

export default PageRoutes;
